<template>
<div class="row">
	<div class="col-sm-12 col-md-7">
		<h5 class="font-weight-normal mt-3">What is your industry?</h5>
	</div>
	<div class="col-sm-12 col-md-5">
		<div class="form-group">
			<select
					name="Industry"
					id="Industry"
					class="form-control form-control-lg"
					required="required"
					v-model="selectedIndustry"
					@change="onSelectedIndustryChange"
			>
				<option value="NA" selected="selected" data-hidden="true">
				-- Choose Industry --
				</option>
				<option
						v-for="option in industryOptions"
						:value="option"
						:key="option.ID"
				>
					{{ option.Name }}
				</option>
			</select>
			<span v-if="state.industryError" id="IndustryError" class="help-block">Please select an industry.</span>
		</div>
	</div>
</div>
</template>

<script>
import store from '../store.js';
import {IndustryData} from '../data.js'

export default {
    name: "IndustrySelector",
    data() {
        return {
            state: store.state,
            industryOptions: IndustryData,
            selectedIndustry: "NA"
        }
    },
    methods: {
        onSelectedIndustryChange() {
            store.updateSelectedIndustry(this.selectedIndustry);
        }
    }
}
</script>

<style scoped>

</style>